export enum PresenceEnum {
    'Absent'='absent',
    'Excusé'='excuse',
    'Annulé'='annule',
    'Présent'='present',
    'Prévu'='prevu',
    'Convoqué'='convoque',
}
